




















































































import { defineComponent } from '@vue/composition-api';

const Privacy = defineComponent({
  // setup() {},
});

export default Privacy;
